import React from 'react';

import {
  Box,
  Button,
  Grid,
  styled,
  Typography
} from '@mui/material';
import {
  BaseModal,
  fields,
  Form
} from 'iron-forge-react-modules';

import { appFormUtil } from 'modules/layer00';
import { useForm } from 'react-hook-form';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();

const ContainerBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3)
}));



export interface IProps {
  sendsEmail?: boolean;
  orderId?: string;
  returnAuthorizationId?: string;
  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  const [fnMutate, tuple] = dataService.useSaveAuditLogEvent({
    orderId: props.orderId,
    returnAuthorizationId: props.returnAuthorizationId,
    sendsEmail: props.sendsEmail ?? false
  });
  const form = useForm<types.IFormState>({
    defaultValues: {
      title: '',
      content: ''
    }
  });



  async function processSubmit(data: types.IFormState) {
    await fnMutate(appFormUtil.trimFormStateValues(data));
    props.onClose();
  }



  const content = (
    <Form.FC onSubmit={form.handleSubmit(processSubmit)}>
      <ContainerBox>
        <Grid
          container
          spacing={1}>
          <Grid
            item
            xs={12}>
            <Typography variant="h2">
              {props.sendsEmail ? "Send email" : "Add a note"}
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}>
            <ControlledTextField
              isRequired
              isDisabled={tuple.loading}
              label="Title"
              fieldKey="title"
              formControl={form.control}
              extraValidationRules={{
                maxLength: 250
              }} />
          </Grid>

          <Grid
            item
            xs={12}>
            <ControlledTextField
              isRequired
              isDisabled={tuple.loading}
              label="Content"
              fieldKey="content"
              formControl={form.control}
              showLengthInLabel
              numLines={5}
              extraValidationRules={{
                maxLength: 1000
              }} />
          </Grid>

          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="flex-end">
            <Button
              disabled={tuple.loading}
              type="submit"
              variant="contained">
              Save
            </Button>
          </Grid>
        </Grid>
      </ContainerBox>
    </Form.FC>
  );

  return (
    <BaseModal.FC
      isOpen
      onClose={props.onClose}>
      {() => content}
    </BaseModal.FC>
  );
};
